/**
 * Created by portiz on 8/24/2018.
 */
import LanguageManager from './language-manager';
import Settings from './settings';
import SessionManager from './session-manager';
import CurrencyManager from './currency-manager';

class ApiCalls {

    /**
     * Insert the classes by the plans for the student
     * @param productsSelected The selected products (string array)
     * @param profileId The profile id (The student id)
     * @param userPlanAgreement (The user plan agreement id)
     * @returns {*|Promise.<T>}
     */
    static insertClassToStudent(productsSelected, profileId, userPlanAgreement)
    {
        const url = Settings.getAssignSeatAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "ProductsSelected": productsSelected,
            "UserPlanAgreement": userPlanAgreement
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Calculates the cost of the plan sending it to the back server
     * @param planId The id of the plan
     * @param quantity The quantity of the plan
     * @returns {Promise.<T>|*}
     */
    static getPlanTotalCosts(planId, quantity)
    {
        const url = Settings.getPlanCostAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "PlanId": planId,
            "Quantity": quantity
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Get the commercial plan details
     * @param planId
     * @returns {*|Promise.<T>}
     */
    static getCommercialPlanDetails(planId){
        const url = Settings.getPlanDetailsAPI();

        let data = {
            "PlanId": planId,
            "Token": SessionManager.getSession(),
            "CurrencyCode": CurrencyManager.getCurrency("USD"),
            "IsSchool": false,
            "IsPrivate": false,
            "OnlyAvailables": true,
            "FilterByLanguage": true,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Call the available plans
     */
    static getCommercialPlans(){
        const url = Settings.getPlansAvailableAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "CurrencyCode": CurrencyManager.getCurrency("USD"),
            "IsSchool": false,
            "IsPrivate": false,
            "OnlyAvailables": true,
            "FilterByLanguage": true,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Creates the subscriptions according to plan id
     * @param planId The id of the plan
     * @param quantity The quantity of selected students
     * @param selectedItems The selected Items
     * @param tokenStripe Stripe
     * @returns {*|Promise.<T>}
     */
    static createSubscriptions(planId, quantity, selectedItems, tokenStripe)
    {
        const url = Settings.getSubscribeUserToPlanAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "SubTokenStripe": tokenStripe,
            "PlanId": planId,
            "Quantity":quantity,
            "LangCode": LanguageManager.getLanguage(),
            "ItemsSelected": selectedItems
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Updates the password profile
     * @param password The password
     * @param passwordRetype The password retype
     * @param profileId The profile Id
     * @returns {*|Promise.<T>}
     */
    static updateProfilePassword(password,passwordRetype,profileId)
    {
        const url = Settings.getProfileUpdatePasswordAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "Password": password,
            "PasswordRetype": passwordRetype,
            "ProfileId": profileId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }

    /**
     * Updates the profile information
     * @param firstName
     * @param lastName
     * @param sex
     * @param dob
     * @param profileId
     */
    static updateProfileInformation(firstName, lastName, sex, dob, profileId)
    {
        const url = Settings.getProfileUpdateInformationAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "FirstName": firstName,
            "LastName": lastName,
            "Gender": sex,
            "DoB": dob,
            "ProfileId": profileId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }

    /**
     * Returns the profile information
     * @returns {Promise.<T>|*}
     */
    static getProfileInformation(profileId) {
        const url = Settings.getProfileInformationReadAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "ProfileId": profileId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Update user main address
     * @param addressLine1
     * @param addressLine2
     * @param city
     * @param state
     * @param country
     * @param countryIsoCode
     * @param zipCode
     * @returns {*|Promise.<T>}
     */
    static updateUserMainAddress(addressLine1, addressLine2, city, state, country, countryIsoCode, zipCode)
    {
        const url = Settings.getUserMainAddressUpdateAPI();
        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "City": city,
            "State": state,
            "Country": country,
            "CountryIsoCode": countryIsoCode,
            "ZipCode": zipCode
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });


    }
    /**
     * Inserts the new password for the main account
     * @param oldPassword The current password
     * @param newPassword The new password
     * @param newPasswordRetype The new password retype
     * @returns {Promise.<T>|*}
     */
    static insertNewPassword(oldPassword, newPassword, newPasswordRetype) {
        const url = Settings.getUserNewPasswordInsertAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "OldPassword": oldPassword,
            "Password": newPassword,
            "PasswordRetype": newPasswordRetype
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }

    /**
     * Returns the student average by a specific lesson
     * @param profileId The student Id
     * @param lessonId The lesson Id
     */
    static getStudentLessonAverage(profileId, lessonId) {

        const url = Settings.getStudentLessonAverageApi();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "LessonId": lessonId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the student average
     * @param {*} profileId : The profile id of the student
     * @param {*} productId : The product id that represents the class
     * @public
     */
    static getStudentAverage(profileId, productId) {

        const url = Settings.getStudentAverageAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "ProductId": productId
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the main account profiles
     * @param {*} profileId : The profile id of the student
     * @public
     */
    static getProfileProducts(profileId) {
        const url = Settings.getProfileProductsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId
        };

        console.log(url, data);
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Return the main account profiles
     *
     * @public
     */
    static getProfiles() {
        const url = Settings.getProfilesAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Returns the user subscriptions details by the user plan agreement id
     * @param userPlanAgreemendId
     * @returns {*|Promise.<T>}
     */
    static getUserSubscriptionDetails(userPlanAgreemendId){
        const url = Settings.getUserSubscriptionsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "UserPlanAgreement": userPlanAgreemendId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Get User subscribed items
     * @returns {*|Promise.<T>}
     */
    static getUserSubscribedItems()
    {
        const url = Settings.getItemsSubscribedUsersAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Return the user subscriptions (With Stripe)
     *
     * @public
     */
    static getUserSubscriptions() {

        const url = Settings.getUserSubscriptionsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Return the user quizzes tries according to the quiz and profile id
     *
     * @param {string} lessonId : The id of the quiz we want to check how many times the uses did tried
     * @public
     */
    static getLessonExams(lessonId) {
        const url = Settings.getLessonExamsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "LessonId": lessonId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the user quizzes tries according to the quiz and profile id
     *
     * @param {string} quizId : The id of the quiz we want to check how many times the uses did tried
     * @param {string} profileId : The id of the profile (student) we want to check
     * @public
     */
    static getQuizzesTries(quizId, profileId) {
        const url = Settings.getUserQuizzesTriesAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "ProfileId": profileId,
            "QuizId": quizId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the user quiz details
     *
     * @param {string} userQuizId : The user quiz id from the selection
     * @public
     */
    static getUserQuizDetails(userQuizId) {

        const url = Settings.getUserQuizDetailsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "UserQuizId": userQuizId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Verifies if the username is available
     * @param username The username to check
     */
    static verifyIfUsernameIsAvailable(username) {
        const url = Settings.getUsernameAvailabilityAPI();
        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Username": username
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData).Availability;
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Return the lessons of the product
     * @param productId : product id representing the class
     */
    static getProductLessons(productId) {
        const url = Settings.getProductLessonsAPI();

        let data = {
            "Token": SessionManager.getSession(),
            "ProductId": productId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Verifies if the email is available
     * @param email The email
     */
    static isEmailAvailable(email) {
        const url = Settings.getEmailAvailabilityAPI();
        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Email": email
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData).Availability);
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Returns the syllabus
     * @param productId The id of the product that represents the class
     * @param lessonId The lesson id
     */
    static getSyllabus(productId, lessonId) {
        const url = Settings.getSyllabusReadAPI();

        var data = {
            "Token": SessionManager.getSession(),
            "ProductId": productId,
            "LessonId": lessonId,
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Registers the user
     * @param username The username
     * @param password The password
     * @param passwordRetype The password retype
     * @param email The email of the user
     * @param firstname The firstname of the user
     * @param lastname The lastname of the user
     * @param phone The phone of the user
     * @param addressLine1 The address of the user
     * @param addressLine2 The address of the user (line 2)
     * @param city The city
     * @param state The state of the user
     * @param countryIso The country ISO
     * @param zipCode The zip code
     * @param country The country
     */
    static registerUser(username, password, passwordRetype, email, firstname,
                        lastname, phone, addressLine1, addressLine2, city, state, countryIso, zipCode, country) {
        const url = Settings.getRegisterMainAccountAPI();

        let data = {
            "Username": username,
            "Password": password,
            "PasswordRetype": passwordRetype,
            "Email": email,
            "FirstName": firstname,
            "LastName": lastname,
            "Phone": phone,
            "DoB": null,
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "City": city,
            "State": state,
            "CountryIso": countryIso,
            "ZipCode": zipCode,
            "Country": country,
            "Gender": null,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Registers the profile
     * @param username The username of the profile
     * @param password The password of the profile
     * @param passwordRetype The password of the profile (retype)
     * @param firstname The firstname
     * @param lastname The lastname
     * @param sex The sex
     * @param dob The date of the birth
     * @returns {*|Promise.<T>}
     */
    static registerProfile(subscriptionId, username, password, passwordRetype, firstname,
                           lastname, sex, dob) {
        const url = Settings.getRegisterProfileAPI();

        let data = {
            "SubscriptionId": subscriptionId,
            "Username": username,
            "Password": password,
            "PasswordRetype": passwordRetype,
            "FirstName": firstname,
            "LastName": lastname,
            "DoB": dob,
            "Gender": sex,
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };

        console.log(url, data);

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Verifies the login
     * @param username The username to check
     * @param password The password
     * @param callback The callback of the user
     */
    static getLogin(username, password, callback) {
        const url = Settings.getLoginAPI();
        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Username": username,
            "password": password
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                callback(JSON.parse(responseData));
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    /**
     * Return the address of the main account
     */
    static getUserMainAddress() {
        const url = Settings.getUserMainAddressAPI();

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSession()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the countries
     */
    static getCountries(countryIso) {
        const url = Settings.getCountriesAPI();

        let data = {
            "LangCode": LanguageManager.getLanguage()
        };

        if(countryIso != null)
            data.CountryIsoAlpha3 = countryIso;

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the states or provinces if the country has one
     * @param countryISO
     * @returns {Promise.<T>|*}
     */
    static getStateProvinces(countryISO){
        const url = Settings.getStateProvincesAPI();

        let data = {
            "CountryIsoAlpha3": countryISO,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(url, fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }
}

export default ApiCalls;


// WEBPACK FOOTER //
// ./src/custom-classes/api-calls.js